<template>
  <div class="atestado-success">
    <div class="d-flex justify-center">
      <v-img class="mb-5" src="@/assets/success-image.png" max-width="100" width="70px" contain></v-img>
    </div>
    <div class="success-message-container" :style="{ backgroundColor: $vuetify.theme.themes.light.soft }">
      <span class="success-message-title" :style="{ color: $vuetify.theme.themes.light.primary }">
        Sucesso!
      </span>
      <div class="success-message">
        Seu atestado de saúde foi adicionado com sucesso! <br /><br />
        Qualquer dúvida entre em contato conosco através do nosso chat ou Whatsapp
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AtestadoSuccess',
  beforeMount() {
    this.$emit('change-show-stepper-header', false)
  }
}
</script>

<style scoped>
.atestado-success {
  display: flex;
  flex-direction: column;
}
.success-message-container {
  display: flex;
  flex-direction: column;
  padding: 30px 15px;
  border-radius: 5px;
}
.success-message-title {
  font-size: 1.5rem;
  text-align: center;
  font-weight: 700;
  margin-bottom: 30px;
}
.success-message {
  font-size: 0.8rem;
  text-align: center;
}
</style>
